export type HighlightLayoutRect = Pick<DOMRectReadOnly, "left" | "top" | "width" | "height">

function geometryKey(values: number[]) {
    return values.map((value) => value.toFixed(2)).join(":")
}

export function getHighlightGeometryKey(
    parentRect: HighlightLayoutRect,
    readerRect: HighlightLayoutRect,
) {
    return geometryKey([
        readerRect.left - parentRect.left,
        readerRect.top - parentRect.top,
        readerRect.width,
        readerRect.height,
    ])
}

export function getHighlightCanvasBoundsKey(parentRect: HighlightLayoutRect) {
    return geometryKey([parentRect.width, parentRect.height])
}
